import { atomWithReset } from 'jotai/utils';

interface ISharePanelOpenValue {
  title?: string;
  href?: string;
}

export const $SharePanelOpen = atomWithReset<ISharePanelOpenValue | false>(false);
